import { EVENT_KEYS, LOADER_EVENTS } from 'presentation/events';

let dispatch;
export const loaderService = async(config, service, ...args) => {
    config = {
        failSilently : false,
        ...config
    };

    dispatch({
        type : config.loaderKey,
        payload : true
    });

    let result;
    try {
        result = await service.apply(null, args);
    } catch(err) {
        if(!config.failSilently) {
            dispatch({
                type : EVENT_KEYS.SERVICE_ERROR,
                payload : err
            });
        }
        throw err;
    } finally {
        dispatch({
            type : config.loaderKey,
            payload : false
        });
    }

    return result;
};

let loaderMap = {};

export const loaderSubscribeInit = (store) => {
    dispatch = store.dispatch;
    store.subscribe(() => {
        let { currentAction, layout } = store.getState();
        if(Object.values(LOADER_EVENTS).includes(currentAction.type)) {
            for (let loaderKey in layout.loaders) {
                let setters = loaderMap[loaderKey] || [];
                setters.forEach((setter) => {
                    setter(layout.loaders[loaderKey]);
                });
            }
        }
    });
};

export const loaderSubscribe = (loaderKey, setter) => {
    let setterList = loaderMap[loaderKey] || [];
    loaderMap[loaderKey] = [
        ...setterList,
        setter
    ]
};
